import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'marktypes',
  urlRoot: 'marktypes'
})

export default withDataFilter(store)
